import { GAP_TOKEN, INPUT_WIDTHS_LOGIC_GROUP_REFINEMENT, ROW_GAP_TOKEN } from '../../constants/inlineLayout';
import { UNIFIED_EVENT } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useLogicGroupRefinement } from '../../hooks/useLogicGroupRefinement';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorUnifiedEventRefinement from './EditorUnifiedEventRefinement';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Select } from 'foundations-components/transitional/components/Select';
import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorUnifiedEventRefinementResponsive = ({
  field,
  inputUse,
  onRefinementChange,
  refinement
}) => {
  const {
    width
  } = useElementSize();
  const {
    isChecked,
    onCheckboxChange,
    onRefinementConditionValueChange,
    onSelectedOptionChange,
    operatorName,
    operatorOptions,
    refinementCondition
  } = useLogicGroupRefinement(field, UNIFIED_EVENT, onRefinementChange, refinement);
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorUnifiedEventRefinement, {
      field: field,
      inputUse: inputUse,
      refinement: refinement,
      onRefinementChange: onRefinementChange
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexWrap: 'nowrap',
    columnGap: GAP_TOKEN,
    rowGap: ROW_GAP_TOKEN,
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        flexShrink: 0,
        width: `${INPUT_WIDTHS_LOGIC_GROUP_REFINEMENT[width.size]}px`
      },
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: isChecked,
        onChange: onCheckboxChange,
        size: "sm",
        children: field.label
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        alignSelf: 'start',
        flexShrink: 0,
        width: `${INPUT_WIDTHS_LOGIC_GROUP_REFINEMENT[width.size]}px`
      },
      children: /*#__PURE__*/_jsx(Select, {
        disabled: !isChecked,
        onSelectedOptionChange: onSelectedOptionChange,
        optionRenderer: option => /*#__PURE__*/_jsx(TypeaheadResultsItem, {
          message: true,
          option: option
        }),
        options: operatorOptions,
        readOnly: operatorOptions.length === 1,
        value: operatorName,
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        alignSelf: 'start',
        minWidth: `${INPUT_WIDTHS_LOGIC_GROUP_REFINEMENT[width.size]}px`
      },
      children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
        inputUse: inputUse,
        condition: refinementCondition,
        disabled: !isChecked,
        filterFamily: UNIFIED_EVENT,
        onChange: onRefinementConditionValueChange
      })
    })]
  });
};
export default EditorUnifiedEventRefinementResponsive;